import AWSHelpers, { getCurrentServiceCredentials, setCurrentServiceCredentials } from './AWSHelpers'

const awsapi = {
  AWSHelpers,
  getCurrentServiceCredentials,
  setCurrentServiceCredentials,
}

export default awsapi
